/* Vegan Chocolate Co — "Cacao" theme behaviour.
   Vanilla, no framework, no build step. Everything degrades to a usable
   static page if JS fails: the filters start on "all", the ethos dossier
   renders its first pillar server-side, and the box summary has real markup. */
(function () {
  'use strict';

  /* --- sticky header --------------------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 70);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- reveal on scroll ------------------------------------------------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '-70px' });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* --- range filter ----------------------------------------------------- */
  var filterBar = document.querySelector('[data-filters]');
  if (filterBar) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-card]'));
    filterBar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var key = btn.getAttribute('data-filter');
      filterBar.querySelectorAll('[data-filter]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      // "Everything" shows the section's own collection (data-default cards);
      // category chips show every card tagged with that collection, including
      // ones hidden from the default view. Grids whose cards carry no
      // data-default at all keep the old show-everything behaviour.
      var hasDefaults = cards.some(function (c) { return c.hasAttribute('data-default'); });
      var shown = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split('|');
        var hide = key === 'all'
          ? (hasDefaults && !card.hasAttribute('data-default'))
          : tags.indexOf(key) === -1;
        card.hidden = hide;
        if (!hide) shown += 1;
      });

      // A filter that matches nothing used to collapse the grid to 0px with no
      // explanation — the shop simply vanished. Say so instead.
      var empty = document.querySelector('[data-filter-empty]');
      if (empty) {
        empty.hidden = shown > 0;
        if (shown === 0) {
          empty.textContent = 'Nothing in “' + btn.textContent.trim() +
            '” just now. Choose another category, or see everything.';
        }
      }
    });
  }

  /* --- ethos pillar selector -------------------------------------------- */
  var pillars = document.querySelector('[data-pillars]');
  if (pillars) {
    var dossier = document.querySelector('[data-dossier]');
    pillars.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pillar]');
      if (!btn || !dossier) return;
      pillars.querySelectorAll('[data-pillar]').forEach(function (b) {
        b.setAttribute('aria-selected', String(b === btn));
      });
      dossier.querySelector('[data-dossier-title]').textContent = btn.getAttribute('data-title') || '';
      dossier.querySelector('[data-dossier-body]').textContent = btn.getAttribute('data-body') || '';
      var noteEl = dossier.querySelector('[data-dossier-note]');
      if (noteEl) noteEl.textContent = btn.getAttribute('data-note') || '';

      // Each principle carries its own photograph; swap it with the copy.
      var imgEl = dossier.querySelector('[data-dossier-img]');
      var src = btn.getAttribute('data-img');
      if (imgEl && src && imgEl.getAttribute('src') !== src) {
        imgEl.style.opacity = '0';
        var swap = function () {
          imgEl.setAttribute('src', src);
          imgEl.setAttribute('alt', btn.getAttribute('data-alt') || '');
        };
        if (imgEl.complete) { setTimeout(function () { swap(); imgEl.style.opacity = '1'; }, 160); }
        else { swap(); imgEl.style.opacity = '1'; }
        imgEl.onload = function () { imgEl.style.opacity = '1'; };
      }
    });
  }

  /* --- box builder ------------------------------------------------------ */
  var box = document.querySelector('[data-box]');
  if (box) {
    var state = {
      size: box.querySelector('[data-size][aria-pressed="true"]'),
      cadence: box.querySelector('[data-cadence][aria-pressed="true"]')
    };

    var money = function (n) {
      return '$' + n.toFixed(2);
    };

    var render = function () {
      if (!state.size || !state.cadence) return;
      var pieces = parseInt(state.size.getAttribute('data-pieces'), 10) || 0;
      var base = parseFloat(state.size.getAttribute('data-base')) || 0;
      var discount = parseFloat(state.cadence.getAttribute('data-discount')) || 0;
      var net = base * (1 - discount);

      var picked = Array.prototype.slice
        .call(box.querySelectorAll('[data-pick][aria-pressed="true"]'))
        .map(function (b) { return b.textContent.trim(); });

      var set = function (sel, value) {
        var el = box.querySelector(sel);
        if (el) el.textContent = value;
      };
      set('[data-out-size]', state.size.getAttribute('data-label') || '');
      set('[data-out-cadence]', state.cadence.getAttribute('data-label') || '');
      set('[data-out-picks]', picked.length ? picked.join(', ') : 'Our pick');
      set('[data-out-total]', money(net));
      set('[data-out-per]', pieces ? money(net / pieces) + ' a piece' : '');

      var saveEl = box.querySelector('[data-out-save]');
      if (saveEl) {
        var saved = base - net;
        saveEl.textContent = saved > 0.005 ? 'You save ' + money(saved) + ' on every box' : '';
        saveEl.hidden = saved <= 0.005;
      }
    };

    box.addEventListener('click', function (e) {
      var size = e.target.closest('[data-size]');
      var cadence = e.target.closest('[data-cadence]');
      var pick = e.target.closest('[data-pick]');

      if (size) {
        box.querySelectorAll('[data-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === size));
        });
        state.size = size;
      }
      if (cadence) {
        box.querySelectorAll('[data-cadence]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === cadence));
        });
        state.cadence = cadence;
      }
      if (pick) {
        var on = pick.getAttribute('aria-pressed') === 'true';
        var picked = box.querySelectorAll('[data-pick][aria-pressed="true"]');
        // Never allow an empty box — the last selected chip cannot be turned off.
        if (on && picked.length === 1) return;
        pick.setAttribute('aria-pressed', String(!on));
      }
      if (size || cadence || pick) render();
    });

    render();
  }

  /* --- welcome popup ---------------------------------------------------- */
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var KEY = 'vcc_welcome_seen';
    var path = window.location.pathname;

    /* People who arrive from one of our paid ads do not get this popup opened on
       them automatically (Mitch, 22 Oct 2026). It covered the product page the ad
       sent them to and blocked Add to cart until they closed it. Our Meta ads tag
       their links utm_medium=paid. The flag lasts the visit, so the next page they
       open does not show it either. Organic visitors still get it, including
       Instagram link-in-bio (utm_medium=social) and unpaid Facebook clicks (fbclid
       on its own is not treated as an ad). Only the automatic open is skipped. */
    var PAID_KEY = 'vcc_from_ad';
    var arrivedFromAd = false;
    try {
      var utm = new URLSearchParams(window.location.search);
      var utmMedium = (utm.get('utm_medium') || '').toLowerCase();
      var utmSource = (utm.get('utm_source') || '').toLowerCase();
      arrivedFromAd = /^(paid|paid_social)$/.test(utmMedium)
        || (/^(facebook|fb|instagram|ig|meta)$/.test(utmSource) && /^(paid|cpc|paid_social)$/.test(utmMedium));
    } catch (e) { arrivedFromAd = false; }
    if (arrivedFromAd) { try { sessionStorage.setItem(PAID_KEY, '1'); } catch (e) { /* private mode */ } }
    var fromAd = arrivedFromAd;
    try { fromAd = fromAd || sessionStorage.getItem(PAID_KEY) === '1'; } catch (e) { /* private mode */ }

    var suppressed = /\/(cart|checkouts?|account)/.test(path) || fromAd;
    if (path === '/pages/pop-a-balloon') return;

    var close = function () {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem(KEY, '1'); } catch (e) { /* private mode */ }
    };

    var open = function () {
      /* Never stack on top of the add-to-cart confirmation. Two dialogs at once
         reads as broken, and interrupting someone who is mid-purchase with a
         first-order discount is the worst possible moment to do it. */
      var added = document.querySelector('[data-cart-added]');
      if (added && !added.hidden) return;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      var field = popup.querySelector('input[type="email"]');
      if (field) field.focus();
    };

    var alreadySeen = false;
    try { alreadySeen = localStorage.getItem(KEY) === '1'; } catch (e) { alreadySeen = false; }

    // A form that has just posted must show its result even on a repeat visit.
    var justPosted = !!popup.querySelector('.popup__code');
    if (justPosted) { open(); }
    else if (!alreadySeen && !suppressed) { setTimeout(open, 6000); }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); close(); }
    });

    // Converting must count as "seen". Previously the flag was written only on
    // dismissal, so the person who actually handed over their email was the
    // one who kept getting the popup on every future visit — exactly backwards.
    var markSeen = function () {
      try { localStorage.setItem(KEY, '1'); } catch (e) { /* private mode */ }
    };
    var popupEmail = popup.querySelector('input[type="email"]');
    var popupNote = popup.querySelector('[data-popup-note]');

    /**
     * Only a REAL conversion counts as "seen".
     *
     * The first version of this fix marked seen on any click of the button,
     * which meant clicking with an empty field silently burned the offer
     * forever and captured nothing — worse than the bug it replaced. An empty
     * or malformed address now gets a readable message and no flag.
     */
    var handleSubmit = function (e) {
      var value = (popupEmail && popupEmail.value ? popupEmail.value : '').trim();
      var looksValid = /^[^\s@,;:<>"']+@[^\s@,;:<>"']+\.[a-z]{2,}$/i.test(value);
      if (!looksValid) {
        if (e) e.preventDefault();
        if (popupNote) {
          popupNote.textContent = value
            ? 'That email address does not look right — please check it.'
            : 'Please enter your email address to get the code.';
          popupNote.hidden = false;
        }
        if (popupEmail) popupEmail.focus();
        return false;
      }
      if (popupNote) popupNote.hidden = true;
      markSeen();
      return true;
    };

    var popupForm = popup.querySelector('form');
    if (popupForm) popupForm.addEventListener('submit', handleSubmit);
    // The Shopify theme wraps this in a real <form>; the static preview does
    // not, so the button is handled directly too.
    popup.addEventListener('click', function (e) {
      if (e.target.closest('button[type="submit"], .popup .btn--solid')) handleSubmit(e);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) { close(); return; }
      // Keep Tab inside the dialog while it is open. Without this, focus walks
      // out into the page behind the scrim after a few stops, which is
      // disorienting for keyboard and screen-reader users.
      if (e.key !== 'Tab' || popup.hidden) return;
      var focusable = popup.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* --- announcement bar rotation --------------------------------------- */
  var bar = document.querySelector('[data-announcement]');
  if (bar) {
    var messages = bar.querySelectorAll('[data-announcement-msg]');
    if (messages.length > 1) {
      var current = 0;
      setInterval(function () {
        messages[current].classList.remove('is-active');
        current = (current + 1) % messages.length;
        messages[current].classList.add('is-active');
      }, 5000);
    }
  }

  /* --- product gallery -------------------------------------------------- */
  var mainImg = document.querySelector('[data-pdp-main-img]');
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.getAttribute('data-full');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === thumb)); });
      });
    });
  }

  /* --- product recommendations (Shopify renders these async) ------------ */
  var recs = document.querySelector('[data-recs]');
  if (recs && !recs.querySelector('.grid-products')) {
    fetch(recs.getAttribute('data-url'))
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = parsed.querySelector('.grid-products');
        if (grid) { recs.querySelector('.wrap').appendChild(grid); }
        else { recs.remove(); }
      })
      .catch(function () { recs.remove(); });
  }

  /* --- mobile navigation ------------------------------------------------ */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    var setNav = function (open) {
      navToggle.setAttribute('aria-expanded', String(open));
      mobileNav.classList.toggle('is-open', open);
      if (open) { mobileNav.removeAttribute('hidden'); } else { mobileNav.setAttribute('hidden', ''); }
    };
    setNav(false);
    navToggle.addEventListener('click', function () {
      setNav(navToggle.getAttribute('aria-expanded') !== 'true');
    });
    // Following a link must close the menu, or a same-page anchor leaves the
    // sheet covering the thing it just scrolled to.
    mobileNav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setNav(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setNav(false);
    });
    // Crossing the desktop breakpoint must not leave a stale open sheet.
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900) setNav(false);
    });
  }

  /* --- deep-link correction ---------------------------------------------
     Landing with a fragment (someone pastes /#join) starts a smooth scroll
     immediately, while lazy images below the fold are still settling. The
     target moves under the scroll and the page overshoots. Re-anchor once
     everything has loaded — clicking an in-page link is unaffected because
     the document is already settled by then. */
  if (window.location.hash.length > 1) {
    var reanchor = function () {
      var target = null;
      try { target = document.querySelector(window.location.hash); } catch (e) { return; }
      if (!target) return;
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      target.scrollIntoView({ behavior: behavior, block: 'start' });
    };
    window.addEventListener('load', function () { setTimeout(reanchor, 250); });
  }
})();

/* --- Add to cart without leaving the page --------------------------------
   The default form post navigates to /cart, which ends the shopping session at
   the exact moment the customer has shown they want to buy. This adds the item
   in the background and confirms it in place instead.

   Written defensively on purpose: if anything at all goes wrong — fetch missing,
   network down, Shopify returning an error — the code steps aside and lets the
   browser submit the form normally. The customer then gets the old behaviour,
   which works. A broken add-to-cart is the worst bug a shop can have, so the
   failure mode has to be "no worse than before", never "nothing happens". */
(function () {
  if (!window.fetch || !window.FormData) return;

  var popup = document.querySelector('[data-cart-added]');
  if (!popup) return;

  var titleEl = popup.querySelector('[data-cart-added-title]');
  var nameEl = popup.querySelector('[data-cart-added-name]');
  var countEl = popup.querySelector('[data-cart-added-count]');
  var imgEl = popup.querySelector('[data-cart-added-image]');
  var lastFocus = null;

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function open() {
    /* If the welcome popup is already on screen, take it down first — the
       customer has just added something, which is a far stronger signal than a
       timer firing. */
    var welcome = document.querySelector('[data-popup]');
    if (welcome && !welcome.hidden) {
      welcome.hidden = true;
      welcome.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem('vcc_welcome_seen', '1'); } catch (e) { /* private mode */ }
    }
    lastFocus = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    var first = popup.querySelector('.btn');
    if (first) first.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  popup.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-added-close]')) { e.preventDefault(); close(); }
  });

  /* Keep any cart counter in the header honest after an add. */
  function refreshCartCount(count) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = String(count);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); }

    /* Belt and braces on a live shop: if ANYTHING in here throws synchronously,
       preventDefault has already fired, so the form must be submitted by hand or
       the button silently does nothing. */
    try {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed ' + res.status);
        return res.json();
      })
      .then(function (item) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { item: item, cart: cart }; });
      })
      .then(function (data) {
        if (btn) btn.removeAttribute('aria-busy');
        /* The kicker above already says 'Added to your cart'. Repeating it in the
           heading wastes the most prominent line in the dialog, so the heading
           carries the product name instead. */
        var name = data.item.product_title || data.item.title || '';
        if (titleEl) titleEl.textContent = name;
        if (nameEl) {
          var variant = data.item.variant_title && data.item.variant_title !== 'Default Title' ? data.item.variant_title : '';
          nameEl.textContent = variant;
          nameEl.hidden = !variant;
        }
        if (countEl) {
          countEl.textContent = data.cart.item_count + (data.cart.item_count === 1 ? ' item' : ' items')
            + ' · ' + money(data.cart.total_price);
        }
        if (imgEl) {
          var src = data.item.image || (data.item.featured_image && data.item.featured_image.url);
          if (src) { imgEl.src = src; imgEl.alt = data.item.product_title || ''; imgEl.hidden = false; }
          else { imgEl.hidden = true; }
        }
        refreshCartCount(data.cart.item_count);
        open();
      })
      .catch(function () {
        /* Anything unexpected: hand back to the browser. The customer gets the
           old full-page behaviour rather than a button that does nothing. */
        if (btn) btn.removeAttribute('aria-busy');
        form.submit();
      });
    } catch (err) {
      if (btn) btn.removeAttribute('aria-busy');
      form.submit();
    }
  });
})();

/* --- Cart quantity and removal -------------------------------------------
   The markup works without any of this: the quantity boxes are a normal Shopify
   cart form and the remove controls are real links to /cart/change. This layer
   only removes the page-reload-and-scroll-back that would otherwise happen, and
   it saves the customer having to find an "Update" button after changing a
   number — a step people routinely miss, then wonder why the total is wrong.

   On any failure it falls through to the plain link or form, so the worst case
   is the behaviour we would have had anyway. */
(function () {
  var form = document.querySelector('[data-cart-form]');
  if (!form || !window.fetch) return;

  function busy(line, state) {
    var el = document.querySelector('[data-cart-line="' + line + '"]');
    if (el) el.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function change(line, quantity, fallback) {
    busy(line, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed ' + r.status);
        /* Reload rather than patching the DOM. Line numbers shift when an item
           is removed, and prices, totals and the shipping meter all have to move
           together — re-rendering by hand is how a cart ends up showing a total
           that disagrees with checkout. */
        window.location.reload();
      })
      .catch(function () {
        busy(line, false);
        if (fallback) window.location.href = fallback;
      });
  }

  form.addEventListener('click', function (e) {
    var link = e.target.closest('[data-remove]');
    if (!link) return;
    e.preventDefault();
    change(link.getAttribute('data-remove'), 0, link.getAttribute('href'));
  });

  form.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty]');
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) { input.value = '1'; return; }
    change(input.getAttribute('data-line'), q, null);
  });
})();

/* --- PDP variant chips → hidden select + price + ATC state ------------- */
(function () {
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) { return; }
  var dataEl = form.querySelector('[data-pdp-variants]');
  var select = form.querySelector('select[name="id"]');
  var groups = Array.prototype.slice.call(form.querySelectorAll('[data-option-chips]'));
  if (!dataEl || !select || !groups.length) { return; }
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants || !variants.length) { return; }
  var priceEl = document.querySelector('[data-pdp-price]');
  var atc = form.querySelector('.pdp__atc');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function selectedValues() {
    var vals = [];
    groups.forEach(function (g) {
      var on = g.querySelector('.chip[aria-pressed="true"]');
      vals[parseInt(g.getAttribute('data-option-index'), 10)] = on ? on.getAttribute('data-option-value') : null;
    });
    return vals;
  }
  function apply() {
    var vals = selectedValues();
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = [v.option1, v.option2, v.option3];
      var ok = true;
      for (var j = 0; j < vals.length; j++) {
        if (vals[j] != null && opts[j] !== vals[j]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }
    if (!match) { return; }
    select.value = String(match.id);
    if (priceEl && typeof match.price === 'number') { priceEl.textContent = money(match.price); }
    var cmpEl = document.querySelector('[data-pdp-compare]');
    var saveEl = document.querySelector('[data-pdp-save]');
    if (cmpEl && saveEl) {
      if (typeof match.compare_at_price === 'number' && match.compare_at_price > match.price) {
        cmpEl.textContent = money(match.compare_at_price);
        cmpEl.hidden = false;
        saveEl.textContent = 'Save $' + ((match.compare_at_price - match.price) / 100).toFixed(2); /* Macro Mike layer: dollars, as on macromike.com.au */
        saveEl.hidden = false;
      } else {
        cmpEl.hidden = true;
        saveEl.hidden = true;
      }
    }
    if (atc) {
      atc.disabled = !match.available;
      atc.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
  }
  groups.forEach(function (g) {
    Array.prototype.slice.call(g.querySelectorAll('.chip')).forEach(function (chip) {
      chip.addEventListener('click', function () {
        Array.prototype.slice.call(g.querySelectorAll('.chip')).forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === chip));
        });
        apply();
      });
    });
  });
  apply();
})();

/* --- PDP gallery video thumb ------------------------------------------- */
(function () {
  var mainImg = document.querySelector('[data-pdp-main-img]');
  var mainVideo = document.querySelector('[data-pdp-main-video]');
  var videoThumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-video-thumb]'));
  if (!mainImg || !mainVideo || !videoThumbs.length) { return; }
  var imageThumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-thumb]'));
  var allThumbs = imageThumbs.concat(videoThumbs);

  function showImage() {
    mainVideo.pause();
    mainVideo.hidden = true;
    mainImg.hidden = false;
  }
  videoThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-video-src');
      if (mainVideo.getAttribute('src') !== src) { mainVideo.setAttribute('src', src); }
      mainImg.hidden = true;
      mainVideo.hidden = false;
      var p = mainVideo.play();
      if (p && p.catch) { p.catch(function () {}); }
      allThumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === thumb)); });
    });
  });
  imageThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', showImage);
  });
})();

/* --- PDP media carousel (images + video in one strip) ------------------ */
(function () {
  var carousel = document.querySelector('[data-pdp-carousel]');
  if (!carousel) { return; }
  var track = carousel.querySelector('[data-pdp-track]');
  var slides = Array.prototype.slice.call(track.querySelectorAll('[data-pdp-slide]'));
  var prev = carousel.querySelector('[data-pdp-prev]');
  var next = carousel.querySelector('[data-pdp-next]');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-goto]'));
  if (!track || !slides.length) { return; }
  if (slides.length > 1) {
    if (prev) { prev.hidden = false; }
    if (next) { next.hidden = false; }
  }

  function current() {
    return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
  }
  function goTo(i) {
    var idx = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
  }
  function sync() {
    var idx = current();
    thumbs.forEach(function (t) {
      t.setAttribute('aria-pressed', String(parseInt(t.getAttribute('data-pdp-goto'), 10) === idx));
    });
    slides.forEach(function (s, i) {
      var v = s.querySelector('video');
      if (v && i !== idx) { v.pause(); }
    });
  }
  if (prev) { prev.addEventListener('click', function () { goTo(current() - 1); }); }
  if (next) { next.addEventListener('click', function () { goTo(current() + 1); }); }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = parseInt(t.getAttribute('data-pdp-goto'), 10);
      goTo(i);
      var v = slides[i] && slides[i].querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
    });
  });
  var timer = null;
  track.addEventListener('scroll', function () {
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(sync, 120);
  });
  sync();
})();
